<template>
  <div class="model-form-container">
    <b-row>
      <b-col md="6" sm="12">
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group>
              <label class="col-form-label"
              >Danh mục<span class="text-danger"> *</span></label
              >
              <Select2
                  v-model="brandName"
                  :class="blur && !brandName ? `select2-error` : ''"
                  :options="brands"
              />
              <label
                  v-if="blur && !brandName"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Vui lòng chọn danh mục</label
              >
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group>
              <label class="col-form-label"
              >Loại SMS/Notification<span class="text-danger"> *</span></label
              >
              <Select2
                  v-model="type"
                  :class="blur && !type ? `select2-error` : ''"
                  :options="smsType"
              />
              <label
                  v-if="blur && !type"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Vui lòng chọn loại SMS/notification</label
              >
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label class="col-form-label"
              >Tiêu đề<span class="text-danger"> *</span></label
              >
              <b-form-input
                  v-model="notifyTitle"
                  :class="blur && !notifyTitle ? `input-error` : ''"
                  maxlength="255"
                  placeholder="Tiêu đề"
                  type="text"
              />
              <label
                  v-if="blur && !notifyTitle"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Vui lòng chọn tiêu đề</label
              >
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label class="col-form-label"
              >Nội dung<span class="text-danger"> *</span></label
              >
              <b-form-textarea
                  id="textarea-auto-height"
                  v-model="content"
                  :class="blur && !content ? `input-error` : ''"
                  max-rows="5"
                  placeholder="Nội dung"
                  rows="5"
              />
              <label
                  v-if="blur && !content"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Vui lòng chọn nội dung</label
              >
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label class="col-form-label">Mô tả tệp thuê bao</label>
              <b-form-textarea
                  id="textarea-auto-height"
                  v-model="description"
                  max-rows="3"
                  placeholder="Mô tả tệp thuê bao"
                  rows="3"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="pycType == 2" cols="12">
            <b-form-group label="Ảnh mô tả">
              <label :for="inputFileId">
                <img :src="uploadUrl" alt="upload-img" class="upload-img"/>
                <input
                    :id="inputFileId"
                    :name="inputFileId"
                    accept="image/png, image/jpeg"
                    hidden
                    type="file"
                    @change="onUploadImage"
                />
              </label>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="6" sm="12">
        <b-row>
          <b-col md="8" sm="12">
            <b-form-group>
              <label class="col-form-label"
              >Thời gian bắt đầu<span class="text-danger"> *</span></label
              >
              <b-form-datepicker
                  v-model="startDate"
                  :class="blur && isValidDate ? 'error' : ''"
                  :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                  locale="vi-VN"
                  placeholder="dd/mm/yyyy"
              />
              <label
                  v-if="blur && isValidDate"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Thời gian bắt đầu không vượt quá thời gian kết thúc</label
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8" sm="12">
            <b-form-group>
              <label class="col-form-label"
              >Thời gian kết thúc<span class="text-danger"> *</span></label
              >
              <b-form-datepicker
                  v-model="endDate"
                  :class="blur && isValidDate ? 'error' : ''"
                  :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                  locale="vi-VN"
                  placeholder="dd/mm/yyyy"
              />
              <label
                  v-if="blur && isValidDate"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Thời gian kết thúc không nhỏ hơn thời gian bắt đầu</label
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4" sm="12">
            <b-form-group>
              <label class="col-form-label"
              >Tần suất gửi/Tuần<span class="text-danger"> *</span></label
              >
              <b-form-input
                  v-model="frequency"
                  :class="blur && !frequency ? `input-error` : ''"
                  :type="'number'"
                  placeholder="Nhập số lần"
              ></b-form-input>
              <label
                  v-if="blur && !frequency"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Vui lòng chọn tần suất gửi/tuần</label
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8" sm="12">
            <b-form-group>
              <label class="col-form-label"
              >Thời điểm gửi trong ngày<span class="text-danger"> *</span></label
              >
              <div class="d-flex">
                <b-form-timepicker
                    v-model="sendInDay"
                    :class="blur && (!sendInDay || !sendInDayAllow) ? `input-error` : ''"
                    locale="vi-VN"
                    placeholder="HH:mm:SS"
                ></b-form-timepicker>
                <!-- <b-button variant="danger" class="btn-icon" style="margin-left: 6px">
                  <feather-icon icon="PlusIcon" />
                </b-button> -->
              </div>
              <label
                  v-if="blur && (!sendInDay || !sendInDayAllow)"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Vui lòng chọn trong khoản thời gian<br/>
                Sáng 8h - 11h30 <br/>
                Chiều 13h30 - 17h
              </label>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8" sm="12">
            <b-form-group>
              <label class="col-form-label"
              >Thời điểm gửi trong tuần<span class="text-danger"> *</span></label
              >
              <div
                  v-for="(item, index) in dateSend"
                  :key="index"
                  :class="`d-flex ${index !== dateSend.length - 1 ? 'mb-1' : ''}`"
              >
                <b-form-datepicker
                    v-model="dateSend[index]"
                    :class="blur && !dateSend[index] ? `input-error` : ''"
                    :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                  }"
                    locale="vi-VN"
                    placeholder="dd/mm/yyyy"
                />
                <b-button class="btn-icon" style="margin-left: 6px" variant="danger">
                  <feather-icon icon="PlusIcon"/>
                </b-button>
              </div>
              <label
                  v-if="blur && dateSend.filter((i) => !i).length"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Vui lòng chọn thời điểm gửi trong tuần</label
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label class="col-form-label mr-2"
              >Tệp thuê bao</label
              >
              <label :for="inputExcelKey">
                <div class="upload-file-btn">Upload file</div>
                <input
                    :id="inputExcelKey"
                    :name="inputExcelKey"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    hidden
                    type="file"
                    @change="onLoadExcel"
                />
              </label>
              <span
                  v-if="detailId && !fileName"
                  class="ml-1 file-name"
                  @click="downloadFile"
              >
                file.xslx
              </span>
              <span v-else class="ml-1 file-name">{{ this.fileName }}</span>
            </b-form-group>
            <!--            <label-->
            <!--              v-if="blur && !listSdt.length"-->
            <!--              class="col-form-label text-danger"-->
            <!--              style="padding-bottom: 0"-->
            <!--              >Vui lòng chọn tệp thuê bao</label-->
            <!--            >-->
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label class="col-form-label">Loại bỏ thuê bao trong blacklist</label>
              <b-form-checkbox v-model="backlist" switch></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-align-right" cols="12">
        <b-button class="btn-icon" variant="danger" @click="onDelete">Xóa</b-button>
        <b-button
            v-if="isAddTemplateBtn"
            class="btn-icon"
            style="margin-left: 10px"
            variant="danger"
            @click="onAddTemplateClick"
        >
          <feather-icon icon="PlusIcon"/>
          Thêm mẫu tin
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormDatepicker,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BFormTimepicker,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
} from "bootstrap-vue";
import Select2 from "v-select2-component";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import UploadIcon from "../../../../assets/images/pages/uploadicon.png";
import useJwt from "@/auth/jwt/useJwt";
import {v4 as uuidv4} from "uuid";
import readXlsxFile from "read-excel-file";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";

export default {
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BFormSelect,
    BTabs,
    BTab,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCardText,
    BInputGroup,
    Select2,
    BFormTimepicker,
    FeatherIcon,
    BFormFile,
    BFormRadio,
  },
  async mounted() {
    await this.getSmsTypeDropdownData(this.pycType);
    await this.getInitDropdownData();
  },
  props: {
    isAddTemplateBtn: {
      type: Boolean,
      default: false,
    },
    pycType: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    inputFileId() {
      return this.inputKey;
    },
    isValidDate() {
      const start = moment(this.startDate);
      const end = moment(this.endDate);

      return end.isBefore(start);
    },
  },
  watch: {
    pycType: {
      immediate: true,
      handler(val, oldVal) {
        this.getSmsTypeDropdownData(val);
        this.type = "";
      },
    },
    frequency: {
      immediate: true,
      handler(val, oldVal) {
        if (val == null || +val < 1) {
          this.frequency = 1;
        } else {
          if (this.dateSend.length > val) {
            this.dateSend = this.dateSend.splice(0, val);
          } else {
            const count = val - this.dateSend.length;
            for (let i = 0; i < count; i++) {
              this.dateSend.push(null);
            }
          }
        }
      },
    },
    sendInDay: {
      immediate: true,
      handler(val, oldVal) {
        const startTimeAm = "08:00:00";
        const endTimeAm = "11:30:00";

        const currentDate = new Date();
        currentDate.setHours(val.split(":")[0]);
        currentDate.setMinutes(val.split(":")[1]);
        currentDate.setSeconds(val.split(":")[2]);

        const startDateA = new Date(currentDate.getTime());
        startDateA.setHours(startTimeAm.split(":")[0]);
        startDateA.setMinutes(startTimeAm.split(":")[1]);
        startDateA.setSeconds(startTimeAm.split(":")[2]);

        const endDateA = new Date(currentDate.getTime());
        endDateA.setHours(endTimeAm.split(":")[0]);
        endDateA.setMinutes(endTimeAm.split(":")[1]);
        endDateA.setSeconds(endTimeAm.split(":")[2]);

        const startTimePm = "13:30:00";
        const endTimePm = "17:00:00";

        const startDateP = new Date(currentDate.getTime());
        startDateP.setHours(startTimePm.split(":")[0]);
        startDateP.setMinutes(startTimePm.split(":")[1]);
        startDateP.setSeconds(startTimePm.split(":")[2]);

        const endDateP = new Date(currentDate.getTime());
        endDateP.setHours(endTimePm.split(":")[0]);
        endDateP.setMinutes(endTimePm.split(":")[1]);
        endDateP.setSeconds(endTimePm.split(":")[2]);

        const valid =
            (startDateA <= currentDate && endDateA >= currentDate) ||
            (startDateP <= currentDate && endDateP >= currentDate);

        this.sendInDayAllow = valid;
      },
    },
  },
  methods: {
    onAddTemplateClick() {
      this.$emit("onAddTemplateClick");
    },
    onDelete() {
      this.$emit("onDelete", this.index);
    },
    async getInitDropdownData() {
      const brands = await useJwt.get("listBrand");
      if (brands.data && brands.data.result) {
        this.brands = brands.data.result.map((item) => ({
          id: item.id,
          text: item.value,
        }));
      }
    },
    async getSmsTypeDropdownData(val) {
      const smsType = await useJwt.get(`smsType?type=${val}`);
      if (smsType.data && smsType.data.result) {
        this.smsType = smsType.data.result.map((item) => ({
          id: item.id,
          text: item.value,
        }));
      }
    },
    getData() {
      this.notifyTitle = this.notifyTitle.trim();
      this.content = this.content.trim();

      const validate =
          !!this.brandName &&
          !!this.type &&
          !!this.notifyTitle &&
          !!this.content &&
          !!this.startDate &&
          !!this.endDate &&
          !this.dateSend.filter((i) => !i).length &&
          !!this.frequency &&
          !!this.sendInDay &&
          !this.isValidDate &&
          this.sendInDayAllow;

      if (!validate) {
        this.blur = true;
        return null;
      }

      this.blur = false;

      return {
        brandName: +this.brandName,
        content: this.content,
        description: this.description,
        backlist: this.backlist ? 1 : 0,
        countNumber: +this.countNumber,
        dateSend: this.dateSend.map((date) => {
          return moment(date).format("yyyy-MM-DD");
        }),
        endDate: moment(this.endDate).format("yyyy-MM-DD"),
        frequency: +this.frequency,
        img: this.img,
        notifyTitle: this.notifyTitle,
        sendInDay: this.sendInDay,
        startDate: moment(this.startDate).format("yyyy-MM-DD"),
        type: +this.type,
        listSdt: this.listSdt,
      };
    },
    setData(data) {
      if (data.id != null) {
        this.detailId = data.id;
      }
      this.brandName = data.brandId;
      this.content = data.content;
      this.countNumber = data.countNumber;
      this.description = data.description || "";
      this.backlist = data.backlist ? true : false;
      this.frequency = data.campaignFrequence;
      this.dateSend = data.dateSend
          ? data.dateSend
              .replace("[", "")
              .replace("]", "")
              .split(",")
              .map((item) => {
                return new Date(item);
              })
          : [];
      this.endDate = data.endDate;
      this.img = data.img ? data.img : null;
      this.notifyTitle = data.notifyTitle;
      this.sendInDay = data.sendInDay;
      this.startDate = data.startDate;
      this.type = data.typeId;
      this.listSdt = data.listNumber
          ? data.listNumber.replace("[", "").replace("]", "").split(",")
          : [];

      if (data.picture) {
        this.uploadUrl = data.picture;
      }
    },
    onUploadImage(e) {
      const file = e?.target?.files[0];
      if (file) {
        const name = file.name;
        if (
            !name ||
            (name.split(".").pop() !== "png" && name.split(".").pop() !== "jpg")
        ) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "File ảnh không đúng định dạng!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }

        const reader = new FileReader();
        reader.addEventListener(
            "load",
            () => {
              this.uploadUrl = reader.result;
              this.img = reader.result;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Upload ảnh thành công",
                  icon: "CheckSquareIcon",
                  variant: "success",
                },
              });
            },
            false
        );
        reader.readAsDataURL(file);
      }
      this.inputKey = uuidv4();
    },
    onLoadExcel(e) {
      if (e?.target?.files[0]) {
        readXlsxFile(e?.target?.files[0])
            .then((rows) => {
              this.listSdt = [];
              for (const row of rows) {
                if (row[0]) {
                  this.listSdt.push(row[0]);
                }
              }
              this.fileName = e?.target?.files[0].name;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Upload tệp thuê bao thành công!",
                  icon: "CheckSquareIcon",
                  variant: "success",
                },
              });
            })
            .catch((e) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Upload tệp thuê bao không thành công, file không hợp lệ!",
                  icon: "CheckSquareIcon",
                  variant: "warning",
                },
              });
            });
      }

      this.inputExcelKey = uuidv4();
    },
    downloadFile() {
      const data = {
        name: "FileSim",
        type: "xlsx",
        report: "FileSim",
        src: "web",
        parameter: {
          ID: this.detailId,
        },
      };

      useJwt.postDownload(`jasper`, "file.xlsx", data);
    },
  },
  data() {
    return {
      brands: [],
      uploadUrl: UploadIcon,
      smsType: [],
      brandName: null,
      content: "",
      description: "",
      backlist: false,
      countNumber: 0,
      dateSend: [],
      endDate: new Date(),
      frequency: null,
      img: null,
      notifyTitle: "",
      sendInDay: "",
      startDate: new Date(),
      type: "",
      inputKey: uuidv4(),
      inputExcelKey: uuidv4(),
      listSdt: [],
      fileName: "",
      blur: false,
      sendInDayAllow: false,
      detailId: null,
    };
  },
};
</script>
<style lang="scss">
.form-control.error {
  border-color: red;
}

.input-error {
  border-color: red !important;
}

.select2-error .select2-container--default .select2-selection--single {
  border-color: red;
}

.model-form-container {
  width: 100%;
  background: white;
}

.upload-img {
  width: 120px;
  height: 120px;
  border: 1px solid gray;
}

.text-align-right {
  text-align: right;
}

.upload-file-btn {
  border-color: #ea5455 !important;
  background-color: #ea5455 !important;
  padding: 0.715rem 0.736rem;
  cursor: pointer;
  display: inline-block;
  font-weight: 400;
  color: #ffffff;
  vertical-align: middle;
  user-select: none;
  font-size: 1rem;
  line-height: 1;
  box-shadow: 0 8px 25px -8px #ea5455;
  border-radius: 5px;
}

.file-name {
  color: rgb(12, 81, 241);
  font-style: italic;
  font-weight: 600;
  width: fit-content;
  text-decoration: none;
}

.file-name:hover {
  color: rgb(26, 64, 154);
  font-weight: bolder;
  cursor: pointer;
  text-decoration: underline;
}
</style>
